export interface Product {
  slug: string;
  title: string;
  description: string;
  price: string;
  priceId: string;
  image: string;
  features: string[];
}

export const products: Record<string, Product> = {
  'excel-colour-picker': {
    slug: 'excel-colour-picker',
    title: "Excel Colour Picker",
    description: "Hover your mouse anywhere and copy the color and RGB/HEX codes to your clipboard and worksheet",
    price: "$1.99",
    priceId: "price_1QIerFJPclTAELitcsK4H51p",
    image: "https://i.imgur.com/ch1TIWs.png?1",
    features: [
      "Pick colors from anywhere on your screen",
      "Automatically copy RGB and HEX codes",
      "Direct worksheet integration",
      "Color history tracking",
      "Compatible with Excel 2016 and later",
      "Free updates for life"
    ]
  },
  'report-builder-plus': {
    slug: 'report-builder-plus',
    title: "Report Builder Plus",
    description: "Create professional reports in minutes with our powerful Excel add-in",
    price: "$39.99",
    priceId: "price_1QIXqmJPclTAELithklXhzwl",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=600&q=80",
    features: [
      "Professional report templates",
      "Custom formatting options",
      "Data visualization tools",
      "Export to multiple formats",
      "Automated report generation",
      "Regular template updates"
    ]
  },
  'formula-master': {
    slug: 'formula-master',
    title: "Formula Master",
    description: "Advanced formula creation and management for Excel power users",
    price: "$29.99",
    priceId: "price_1QIXqmJPclTAELithklXhzwm",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=600&q=80",
    features: [
      "Formula library with 500+ functions",
      "Syntax highlighting",
      "Error checking and validation",
      "Formula documentation",
      "Custom function creation",
      "Version control for formulas"
    ]
  }
};